import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable } from 'rxjs'

import { ApiHttpService } from '@flowx/designer/shared/api/api-http.service'

import {
  DocumentContextReference,
  GenerateFromSequenceRequest,
  GenerateProcessFromDocumentResponse,
  GenerateProcessFromImageResponse,
  GenerateProcessRequest,
  GenerateProcessResponse,
  SendFeedbackPayload,
} from '../../../types/ai.types'

@Injectable({ providedIn: 'root' })
export class AiAnalystApi extends ApiHttpService {
  #analystV1 = `ai-analyst/api/v1/analyst`
  #analystV2 = `ai-analyst/api/v2/analyst`
  #analystV5 = `ai-analyst/api/v5/analyst`

  constructor() {
    const baseUrl = inject<string>('BASE_URL' as any)
    const httpClient = inject(HttpClient)

    super(baseUrl, httpClient)
  }

  generateProcess(payload: GenerateProcessRequest): Observable<GenerateProcessResponse> {
    return this.post(`${this.#analystV5}/json`, payload)
  }

  insert(payload: GenerateFromSequenceRequest): Observable<GenerateProcessResponse> {
    return this.post(`${this.#analystV5}/insert`, payload)
  }

  generateProcessFromImages(formData: FormData): Observable<GenerateProcessFromImageResponse> {
    return this.post(`${this.#analystV5}/image/translate`, formData)
  }

  extractProcessFromDocument(
    documentContextReference: DocumentContextReference
  ): Observable<GenerateProcessFromDocumentResponse> {
    const { documentId: collection_db, name: process_key } = documentContextReference

    return this.post(`${this.#analystV1}/process/extract`, { collection_db, process_key })
  }

  extractProcessFromBpmnFile(formData: FormData): Observable<GenerateProcessResponse> {
    return this.post(`${this.#analystV2}/bpmn/translate`, formData)
  }

  sendFeedback(payload: SendFeedbackPayload): Observable<string> {
    const { reason, feedbackType, message, requestId, sessionId } = payload

    return this.post(`${this.#analystV1}/feedback`, {
      feedback: {
        reason,
        response: feedbackType,
        user_message: message,
      },
      request_id: requestId,
      session_id: sessionId,
    })
  }
}
